module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct-top",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3: To War in the Bridal Suite")])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_vm._v("1943–1945")]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("N HIS LUGGAGE")]), _vm._v(" for Fort Bragg, Kurt carried a typewriter, thinking he was beginning an adventure worthy of Hemingway and that “this was indeed first-rate literary material, of interest to a large readership.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn1",
      "id": "ch3-fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The typewriter was too big to fit inside the locker under his bed, so he left it out, where it would indicate he was a rarefied foot soldier, if ever there was one. Returning to the barracks one afternoon, he discovered it had been stolen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the rifle range he was a natural, having practiced for years on handguns and weapons in his father’s collection. “I had learned to fire a .45, I learned how to do that when I was a kid.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn2",
      "id": "ch3-fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The M-1 Garand .30-caliber semiautomatic was a “wonderful rifle.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn3",
      "id": "ch3-fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" He taught himself how to take apart, reassemble, and fire a Browning Automatic Rifle because he admired its versatility as a light machine gun."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn4",
      "id": "ch3-fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" His assigned duty was assembling, firing, and maintaining the army’s most powerful piece of field artillery, the 240-millimeter howitzer that threw a 360-pound shell more than fourteen miles. “We had all we could do to take care of that monster.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn5",
      "id": "ch3-fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Yet despite thirteen weeks of training on tactics and weapons, Vonnegut later claimed he was unprepared to be an infantryman."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn6",
      "id": "ch3-fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Luckily, he qualified for the Army Specialized Training Program (ASTP) based on his aptitude test scores and IQ. If he completed the ASTP course of study, consisting of eighteen months spread over six three-month terms, he would graduate with a four-year degree in engineering from the University of Tennessee and an officer’s commission."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn7",
      "id": "ch3-fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" At the beginning of the summer, he left for Carnegie Mellon University in Pittsburgh to study introductory mechanical engineering. In September he continued his coursework at the University of Tennessee in Knoxville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His classes covered thermodynamics, mechanics, and machine tools. “I did badly again,” he said years later. “I am very used to failure, to being at the bottom of every class.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn8",
      "id": "ch3-fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" But he didn’t fail. He received a 68 in thermodynamics; an 85 in shop practice; a 68 in calculus; an 85 in statistics and dynamics; and an 86 in mechanical engineering drawing—a C+ average."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn9",
      "id": "ch3-fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" For friendship, Kurt preferred the company of “boisterous, prosperous” scientists from nearby Oak Ridge National Laboratory. Over a drink, the chemists, technologists, and physicists became loose-lipped about what they were working on. Most could only speculate about their mysterious work. A publicist for the lab, Richard Gehrman, confided to Vonnegut that his job was to keep the bibulous men of science guessing about how exactly they were contributing to top-secret projects."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn10",
      "id": "ch3-fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HOSE SIX")]), _vm._v(" months of studies at the University of Tennessee didn’t lead to a promotion, as it turned out. In the spring of 1944 the army brass canceled the ASTP program because an additional fifty thousand men were needed to support the Allies’ secret plans for D-day. Private Vonnegut was reassigned to the 106th “Golden Lion” Division, Second Battalion, 423rd Regiment and ordered to report to Camp Atterbury in Indiana to train as an intelligence and reconnaissance (I&R) scout. The forty-thousand-acre Camp Atterbury was close to Indianapolis, at least, and he could go home on weekend passes."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn11",
      "id": "ch3-fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jane was in Indianapolis again as well, having graduated Phi Beta Kappa in English from Swarthmore. Kurt, thinking he was still in the lead for courting her, was writing her often and calling from the base pay phone. What he didn’t know was that Kendall Landis was writing her just as assiduously. Landis had suspended his studies at Swarthmore at the end of his freshman year and enlisted as a cadet in the naval aviator program, which, if he didn’t wash out, would lead to a commission. He loved Jane: “She was marvelous, and with her challenging intellect, she was constantly suggesting that I read books while I was in the Navy and I would report back to her on several of these books and we kept up a lively correspondence.” To him, Jane was his girlfriend back at home."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn12",
      "id": "ch3-fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("S A")]), _vm._v(" scout in a six-man squad, Vonnegut learned yet more battlefield skills at Camp Atterbury: patrolling, setting up observation posts, interpreting maps and aerial photos, and fighting hand-to-hand combat. His squad leader, Sergeant Bruce Boyle, instructed the men to choose a buddy."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn13",
      "id": "ch3-fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Vonnegut paired up with a sardonic Irish-Catholic from Pennsylvania named Bernard V. O’Hare. For the duration, or until death, they were instructed to share food, ammunition, gear, clothing, and a blanket in freezing weather, if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("O’Hare was a short man with a plain face—a big nose and high forehead—who smoked as much as Vonnegut, drank heavily, and talked laconically. His ambition was to practice law in his father’s firm after the war. Vonnegut, in contrast to O’Hare’s wry outlook, came off as a “tall, young, loudmouth guy. He was always talking and laughing and telling people what to do.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn14",
      "id": "ch3-fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In May, Kurt planned a surprise for his folks. For Mother’s Day, he would arrive home on a three-day pass, unannounced, spit-and-polished in his uniform. Alice was visiting them too, married now to James Carmalt Adams, a University of Virginia graduate who had “majored in fun,” said Jim’s sister Donna, and was currently away on duty as a lieutenant flying spotter planes in the Army Air Corps."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn15",
      "id": "ch3-fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Alice and Jim had known each other as children at Lake Maxinkuckee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edith and Kurt Sr. had been residing in their new Williams Creek home since Kurt Jr.’s freshman year at Cornell. Williams Creek, said the developer, in a classic piece of sales hyperbole, was the “Switzerland of Marion County,” Indiana—four miles of curving streets through prairie hills. This time, Kurt Sr. had designed the two-story brick contemporary home himself. There was a large living room, a library, dining room, four bedrooms on the second floor, and a two-car garage. And in the basement, he built a workshop with a kiln for one of his hobbies, pottery making. Kurt Jr. found the house modest in size with a pleasant setting in the woods."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn16",
      "id": "ch3-fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Their income was steady now because Kurt Sr. had been working as a technician in connection with the war effort, first at the Air Support Command Base in Columbus, Indiana, forty miles south of Indianapolis, and then as superintendent of materials control at Fall Creek Ordnance plant near his home."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn17",
      "id": "ch3-fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For Edith, however, the smaller house was a distressing step down. Few people outside her family knew, or would believe, that the plump, suburban Mrs. Vonnegut with the dyed dark hair and severe expression had once been a red-haired American heiress illuminating the social season in Edwardian London; that heel-clicking Prussian suitors right out of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Merry Widow")]), _vm._v(" had vied for her hand. Gone were the servants she had expected would always take care of the humdrum necessities of life. Under her window, no yardman raked up leaves on the lawn from beneath the elms, maples, and oaks. No maid straightened up her room, no cook made their meals. Even so, right before the Germans invaded France in 1940, she and Kurt Sr. had cashed the two remaining bonds left to them by his mother and spent three weeks in Paris. Said a relative, “It was going out with flair—all banners flying.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn18",
      "id": "ch3-fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" She adored that kind of melodrama and continued to infuse her short stories with it—stories typed by a secretary she couldn’t afford—despite the fact that magazine editors kept returning her purple romances like bad checks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After spending Friday and Saturday at home relaxing on leave, Kurt was awakened by Alice early Sunday morning, Mother’s Day. Something was wrong with Mother, she said. Together, they went quietly into her bedroom, where Kurt bent over his mother. He left to get his father, who was sleeping in another room."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn19",
      "id": "ch3-fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Edith Vonnegut, age fifty-six, was dead from an overdose of sleeping pills.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was no note by the bedside."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn20",
      "id": "ch3-fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" There didn’t need to be, although she might have left some words to assuage her family’s grief. Edith Vonnegut’s upper-class ideology had failed her. Faced with adversity, she couldn’t adjust her hopes, her pretensions, not even her existence to the changes in her situation. Lying in bed for many days at a time, too unhappy to rise, she listened disconsolately to the radio and the laughter that might just as well have been directed at her. Later in his life, Vonnegut attributed his mother’s death to a refined nature that wasn’t strong enough to stand up to the times. “It was the war itself that wrecked my mother, and not war against Germany.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn21",
      "id": "ch3-fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" The simple truth was, Edith Vonnegut deigned not to go on living if she had to be like everybody else."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn22",
      "id": "ch3-fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The coroner ruled her death an accident, although Kurt Sr., according to his younger son, acknowledged to older relatives—not to his children—that his wife had killed herself."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn23",
      "id": "ch3-fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" He telephoned the local newspapers requesting that no news about her death or obituary appear. After his wife’s funeral in Indianapolis’s Crown Hill Cemetery, Kurt Jr. later wrote, his father became “a good man, in full retreat from life.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn24",
      "id": "ch3-fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("O HER")]), _vm._v(" youngest child, Edith Vonnegut left a bedeviling “legacy,” as he called it—“an air of defeat has always been a companion of mine.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn25",
      "id": "ch3-fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Disquieting thoughts about self-destruction stung him throughout his life because of her deliberately timed death on Mother’s Day. It jeered at his devotion. He inferred that she had not loved him, which created a self-hating syllogism: she did not love me; I didn’t love her enough; therefore, I am a failure at love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the rest of his life, he directed people’s attention to the manner of his mother’s death as if it were something they should know about him. Meeting, for example, Donald M. Fiene, in 1972, then a PhD candidate in Slavic languages and literature at Indiana University, he brought it up almost immediately, Fiene recalled."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn26",
      "id": "ch3-fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" At a literary festival, fellow Indiana novelist James Alexander Thom remembered that Vonnegut “was warm, droll and charming as usual, but tended to steer the conversation toward suicide.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn27",
      "id": "ch3-fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps he talked about it often because he was never finished seeking a satisfactory explanation for why his mother would kill herself; on the other hand, he also may have sought ways to bring up the subject out of loyalty to her—a recognition of how she suffered—especially since his father didn’t want his wife’s death publicly acknowledged and refused to talk to his children about it. Another possibility is that Vonnegut felt guilty and wanted reassurance of some kind. What’s certain is that his mother’s suicide permanently erased some of life’s luster for him. Later, when he began to write fiction, his obsession with self-destruction edges his fiction like a black border. As a character in one of his novels later says, “Sons of suicides find life lacking.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn28",
      "id": "ch3-fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" His fictional mothers too are always either morbid, crazy, or suicidal. One of them, formerly a beautiful woman in a Midwestern town as Edith Vonnegut was, swallows Drano and suffers a gruesome death. At least, says the narrator drily, “my mother ate sleeping pills, which wasn’t nearly as horrible.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn29",
      "id": "ch3-fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nothing could change that ghastly Mother’s Day in Williams Creek, but Vonnegut knew what would have made his mother happier had she lived. She wanted to be a writer living on Cape Cod, where her family had spent halcyon weeks in the summer. As a retributive act, a gift to her spirit, he might try one day to do the same thing."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn30",
      "id": "ch3-fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ESS THAN")]), _vm._v(" a month after his mother’s death, Vonnegut climbed into a jeep on June 15, 1944, and rode in a parade through Indianapolis’s Monument Circle. The Normandy Invasion, D-day, had taken place just nine days earlier. Knowing he would be leaving soon, he decided he should propose to Jane.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His grief over his mother’s death was reflected in his desperate attempt to force Jane to say yes. He tore open his shirt, exposing his chest. Dangling from a chain around his neck was a bloody molar, removed by his dentist. “This is how much I love you!” he pleaded, trying inarticulately to make a connection between sacrifice, pain, and love. Another version in the family lore describes him going down suddenly on one knee in her living room, as her astonished father looked on."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn31",
      "id": "ch3-fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" She did not say yes and gave no indication that she ever would.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thus by late summer nothing between them had been resolved. Jane left for Washington, D.C., to begin a job as a clerk analyst in the counterintelligence branch of the Office of Strategic Services (OSS), the forerunner of the Central Intelligence Agency (CIA) located at Twenty-fifth Street and E Street NW. Meanwhile, Kurt’s division, the 106th, spent all of September packing for overseas—a huge process for fifteen thousand soldiers and their equipment—to relieve the Second Division in Belgium at the front.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AITING FOR")]), _vm._v(" the division when it reached New York was the RMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Queen Elizabeth,")]), _vm._v(" then the largest passenger ship ever built, painted in wartime colors of battleship gray. Its steel hull was a thousand feet long with a “great big wide entrance door, as big as a wall,” said one of the men, awed, “and we went in there.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn32",
      "id": "ch3-fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut discovered that he had been assigned, ironically, to the bridal suite on the top deck, airier and more spacious than the decks down below. On the morning of October 17 the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Queen")]), _vm._v(" shoved off into the Hudson. Thousands of men on deck crowded against the railing and even climbed the rigging, cheering the Statue of Liberty. As protection against German submarines patrolling the eastern coast, a blimp followed them out to sea for two days, and then they were alone. The Grey Ghost, as it was called, moved the troops at an impressive thirty knots (thirty-five miles per hour).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In Cheltenham, England, where the 106th reassembled two weeks later, camp life was routinized and unexciting. Then orders in late November to attend information sessions about the enemy—their uniform insignias, light weaponry, and language—made things more interesting. Like travelers who were about to meet the locals, Vonnegut and the others sat in rows repeating German phrases, most of which Kurt remembered from two years of German at Shortridge High School. The only other man in his squad who understood as many words was Robert Kelton, drafted during his sophomore year at the University of Illinois, Urbana-Champaign. Finally, everyone received bundles of warmer clothes: long underwear, long wool socks, four-buckle overshoes, wool sweaters, and knit caps. Rumor had it the division was being sent to the Ardennes Forest, where it would be snowy and cold. The good news was that the Ardennes sector had been quiet for months.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When Vonnegut and the rest of the 423rd Regiment crossed the English Channel on December 6 and waded ashore at Le Havre at dawn, it began to rain. Some of the men laughed and made cracks about “Sunny France.” Surrounding him in the town was the first evidence of combat he had seen: bomb craters, burned-out buildings, and German antiaircraft guns pointed skyward. In a field nearby lay the remains of a crashed Allied bomber."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn33",
      "id": "ch3-fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Vonnegut hiked himself over the tailgate of a transport truck and found a spot on a bench inside. Studying the faces of the men as they climbed aboard, his rifle clutched upright between his knees, he felt proud. He had made a choice, one that showed commitment and responsibility. Bernard had once called him “an accident,” which unfortunately his recent failures seemed to bear out. But what he was doing now was honorable. It testified to his value, and he felt “utterly beyond reproach.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn34",
      "id": "ch3-fn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" The muddy trucks, loaded up at last with human cargo, growled into gear and joined the swaying convoy headed toward Dieppe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At first the landscape resembled Indiana—flat and rural. The trees had lost their leaves and smoke curled from the chimneys of farmhouses. But over the course of a week, as the trucks rode higher and higher, through the mountains of eastern Belgium and Luxembourg, the road penetrated forests of snow-covered evergreens and the men could see their breath. Lining the ditches, like a traffic jam bulldozed out of the way, were hundreds of German tanks and trucks, strafed and burned-out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The truck ride ended in the Belgium village of St. Vith, the final bivouac before moving up to the front. The 106th Division was there to replace the Second Division, man for man, gun for gun—every position on twenty-seven miles of the Siegfried Line that had been seized from the Germans the previous August. Jumping down off the tailgate, Vonnegut heard shouts of “You’ll be sorry!” and “Good luck, assholes!” as old hands observed with glee the clean uniforms and shaven faces of their fresh, untried replacements. Then after two days of organizing, the 106th began a twelve-mile eastern march into a hilly portion of western Germany known as the Eifel, part of the Ardennes Forest lying across the continuous borders of France, Belgium, and Luxembourg. Vonnegut’s regiment, the 423rd, together with the 422nd, took up positions atop fir-covered Schnee Eifel (Snow Mountain), the most exposed salient of the entire American front. Below was a valley, rimmed by mountains on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One night a bright moon came out, and beyond the eastern slope where the Germans were waiting, the snow-covered valley shone. From somewhere out there, the newly arrived Americans could hear the clink of mess kits and the squeaking of mechanized vehicles.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("T")]), _vm._v(" 5:30 "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AM")]), _vm._v(" on December 16, 1944, the sky flashed red, green, amber, and white as flights of German “Screaming Meemies” with ear-splitting shrieks tore over the treetops on their way to destroy St. Vith. Wire communications failed and radio frequencies were jammed. The ferocious impact of shells from fourteen-inch German railroad guns shook the earth as a coordinated artillery barrage fell on the line companies, unit command posts, road intersections, and artillery batteries—all the division’s strong points.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the start of Operation Autumn Mist, Hitler’s last gamble to dash to the sea 120 miles away. Two hundred thousand German troops—crack, battle-tested infantry—protected by six hundred carefully hoarded Panther and Tiger tanks, were attempting to punch a hole in the American line of eighty thousand troops. And as Hitler’s generals knew, the weakest point in the Americans’ defense was the salient of the 423rd and 422nd regiments, because the 106th had replaced the Second without making a single strategic change. (Later, as the German offensive progressed east to west, it created a bulge: hence, the Battle of the Bulge.) At 9:00 "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AM,")]), _vm._v(" a second German artillery barrage, which a GI reported to be “unbelievable in its magnitude,” began pounding the two regiments, trying to erase them from the forest floor."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn35",
      "id": "ch3-fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the next three days, the German high command hammered at the 423rd and the 422nd, slowly encircling the two regiments by coming around the Schnee Eifel from the south through the Prüm Corridor, and linking up with units coming into Schönberg from the north along the Andler–Schönberg road, intending to snip the Americans off at the base and open a giant gap in the Allies’ offensive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the nineteenth, Vonnegut’s regimental commander, Colonel C. C. Cavender, ordered Sergeant Boyle’s reconnaissance squad to report on the right flank. Boyle, Vonnegut, Bob Kelton, Richard Davis, Bernie O’Hare, and Bill Sieber set out and quickly encountered a few enemy columns closing in. Continuing on, they entered a thicket of firs that ended abruptly at the edge of a farmer’s field. On all sides the snap and sputter of small arms fire sounded like rice falling on a tin pan. Sieber signaled that he would leave the safety of the tree line first. Venturing out a few yards, he glanced left, right, then a rifle cracked on a ridge and he fell over. He raised himself on one elbow, dazed. “I need a medic, I’m hit.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The squad weighed the idea of one of them running out, grabbing Sieber by the heels, and dragging him back while the others laid down fire. But suddenly a mortar round exploded within a dozen yards. Before the enemy could readjust, the men hightailed it back the way they’d come through the woods, kicking up the snow like surf.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When they reached headquarters, Kelton requested a medic. Colonel Cavender denied permission because the regiment was about to surrender, he said, and he didn’t want the men spread out."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn36",
      "id": "ch3-fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Vonnegut, hearing Sieber was going to be left behind, realized he was not a hero-scout doing something fine but a kind of flotsam floating on the surface of events. Years later, he remembered his rage at feeling powerless: “We’re so smart, we can go out where the real soldiers haven’t been yet, and find out what’s out there! And our whole purpose was to either step on mines or to draw fire. Nobody knows what’s out there and we’re so fucking smart we’re going to find out!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn37",
      "id": "ch3-fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He found a swale to lie down in and wait. A dozen or so other men collapsed in exhaustion beside him. They had only a few rounds each; someone suggested they fix bayonets to prepare for the worst. An odd feeling came over him, as if the pandemonium would be resolved now. Whatever happened, it was just about over. “It was nice there for a few minutes.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn38",
      "id": "ch3-fn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From the forest surrounding them, a German-accented voice, amplified by a loudspeaker, echoed through the late afternoon gloom. “We can see you. Give up.” When no one got to his feet, hands up, German half-tracks lowered their antiaircraft guns and fired into the branches above Vonnegut and the others, sending bursts of shrapnel in all directions. Wounded men screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Come out!” ordered the voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut got to his feet and rapidly began breaking down his weapon, fumbling with his frozen fingers to remove the piston, the trigger mechanism, and the bolt, the pieces falling into the snow. Last, he grabbed the barrel and slung the rifle, end over end, as far as he could. It landed in a creek. O’Hare, paging haphazardly through his phrasebook, shouted, “Nein Scheissen!” to the advancing German troops, thinking he was pleading “Don’t shoot!” They laughed, including one who looked to be about fifteen carrying a machine gun. What O’Hare had said was “Don’t shit!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn39",
      "id": "ch3-fn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut put his hands on top of his helmet and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ENS OF")]), _vm._v(" thousands of American prisoners marched east, two and three abreast, in a dark green river flowing for miles over the snow, its course shaped by German guards. The sun had set almost precisely at the time of Vonnegut’s capture, and as he trudged beside the members of his squad it grew dark. After a couple of hours, the guards indicated that everyone was to lie down in the open field they were crossing. Vonnegut slept belly-to-butt with the other scouts, turning over every half hour or so."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn40",
      "id": "ch3-fn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" At dawn, the march continued.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the next two days, he stumbled along as “the supermen marched us,” he wrote later, until Thursday morning, December 21, when the column arrived at a railroad siding of freight cars at Geroldstein, Germany, east of Prüm and west of Koblenz."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn41",
      "id": "ch3-fn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" The guards threw open the doors of boxcars and ordered them to get in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut got a whiff of fresh cow dung inside."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn42",
      "id": "ch3-fn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" With their rifle butts, the Germans packed in about sixty captives before sliding the doors shut and locking them. There was room enough to stand or squat, but “we literally could not all find space to lie flat at one time,” said one of the prisoners."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn43",
      "id": "ch3-fn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Except for cracks between the slats, the only air and daylight came from louvered openings in each of the four corners. It took almost two days to load several thousand men onto dozens of cars; the train didn’t get under way until nightfall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eighteen hours later, on the morning of the twenty-third, the POWs could see the Rhine River through the boxcar slats at Koblenz. In late afternoon, they felt the train slow as it rumbled into a railway yard marked "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIMBURG.")]), _vm._v(" Sounds of the locomotive being disconnected made them wonder if they’d reached a camp. Then the engine chugged away, leaving them behind."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn44",
      "id": "ch3-fn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A few hours passed, then red flares began falling from the sky, accompanied by air raid sirens and the rumble of planes growing louder. Low-flying British de Havilland Mosquito bombers, assuming the train was carrying German supplies, swooped down for an easy kill. There were shouts of “Stay in the car! It’s safer in the car!” but hundreds of men, freed by the guards, leaped off and tried to run away."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn45",
      "id": "ch3-fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Those who headed straight out from the train entered a curtain of explosions and disappeared. Others took cover, or wobbled in the direction of a barbed-wire fence where there was a concrete shelter. Only one boxcar received a direct hit, killing sixty-three men inside. The bombers peeled off. Lying between the craters in the yard were dozens of dead GIs, some still clutching a piece of bread doled out earlier in the day. In Vonnegut’s boxcar, the men could hear pleas from someone out there begging to be shot."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn46",
      "id": "ch3-fn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The train didn’t move on Christmas Eve day as rails were repaired and another locomotive was found. The men sang Christmas carols that night, and the interior of a few boxcars glowed with pale light from stubby candles, retrieved from the pockets of dirty field jackets. Sometime the day after Christmas the train started up again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They traveled to a second destination, the POW camp at Bad Orb, but, like a plague ship, were refused because the camp was over capacity. The prisoners spent another day swaying in the boxcars until they arrived at Stalag IV-B in Mülhberg, where the guards ordered them off. Instead of leading them through the main gate, however, they herded everyone to a grove of pine trees and instructed them to lie down in the snow. During the night, some men froze to death.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("The next day, Vonnegut stood near the western wire of the camp, stamping his feet to ward off frostbite, waiting in line for hours to be processed. At the main gate, an Australian attached to the Royal Air Force Bomber Command, Geoff Taylor, watched a “large part of an American infantry division—the 106th—stumble into captivity.”")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("Never before have you seen men so near the end of their tether. Plagued with dysentery, twisted with frostbite, starving, dirty, unshaven, staggering on their feet from exhaustion, a long line of men stumbles endlessly into the camp.")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Captured before they knew what hit them, marched hundreds of miles into Germany, stepping over the bodies of comrades who slumped to die in the snow, jolted for days in cattle-trucks and boxcars that were strafed and bombed by the Allied air-fighters, the Americans are macabre burlesques of men.")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("Sometimes a man staggers and bumps the man next to him and they snarl weakly at each other. They are too shocked and dazed to do otherwise. The frosted air is alive with the bark of men coughing. A lot of them won’t live to walk again. This is the end of the road. Outside the wire, by the Kommandantur office, a mountain of GI battle helmets and liners grows visibly bigger, dwarfing the Germans who stand by it. Inside our barracks, confusion reaches fantastic heights.")]), _vm._v(" "), _c('p', {
    staticClass: "exi"
  }, [_vm._v("It’s just as well we organized the bunks and tin-bashed mugs and plates for the new arrivals. The shambles would have been unimaginable had we not. As it is, our carefully-balanced world of unwritten taboos, tribal laws and customs reels under the impact of thousands of men so shocked by their experiences that many are little more than animals stumbling erect."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn47",
      "id": "ch3-fn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("As the men came in through the main gate, tossing their helmets in a pile and receiving cast-off, frozen clothing with a distinctive red triangle to signify POW, a wagon passed, heaped with the bodies of Russians, dead from starvation and malnutrition. Hatred between the Russians and the Nazis ran deep, and the Russians were being allowed to starve, forced to feed themselves with the garbage and leftovers the British and Western European prisoners would not eat."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn48",
      "id": "ch3-fn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On his third day in camp, Vonnegut was given a postcard as required by the Geneva Convention. He assured his family that he had come “through the whole God-awful slaughter without a scratch.… We prisoners will be the first sent home when peace is won, and then for a 90-day leave. This life is not bad at all. Contact the Red Cross for advice on parcels and dispatch them immediately.” He asked for cigarettes “because they serve as money here and would make life considerably more lush.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn49",
      "id": "ch3-fn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He wandered around the camp for a few days cadging smokes, attended a performance of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Cinderella")]), _vm._v(" by the British in drag (“I should have left when midnight struck … lackaday, fucked my luck”), then a bit of news came his way."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn50",
      "id": "ch3-fn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" With the stalag so overcrowded, a work detail was forming for the city of Dresden. During roll call one morning, the Germans came down the line and said, “You … you … you.” Eventually 150 POWs from the 106th were selected, including Vonnegut, for Arbeitskommando 557, departing Stalag IV-B for Dresden on January 12, again by train.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just days before, Kurt Sr. had received a telegram from the War Department saying his son was missing in action as of December 21, 1944. “That’s that,” Uncle Alex wrote sadly to Walt Vonnegut’s wife, Helen."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn51",
      "id": "ch3-fn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Kurt’s family would not receive his postcard from Stalag IV-B for months and didn’t know whether he was alive or dead. Until then, except for a handful of men in the Arbeitskommando who knew him by name, he was just another prisoner living from moment to moment.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RESDEN, ROYAL")]), _vm._v(" residence of dukes and kings of Saxony since the Middle Ages, whose Baroque skyline had inspired painters such as Canaletto, where Friedrich Schiller had written “Ode to Joy,” and which Napoleon had seized for his imperial command, greeted the 150 POWs trudging into the city on January 12, 1945, with a billboard proclaiming "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TRINK COCA-COLA.")]), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn52",
      "id": "ch3-fn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Modernity had long since come to Germany’s seventh largest city, resting snug in a bend of the Elbe River. But the first half of the twentieth century was just the patina on seven centuries of culture that had elevated Dresden to the title of “Florence on the Elbe.” So deep and rich was Dresden’s past that, after more than half a millennium as a center of art and technology, its museums preserved a continuous record of Western achievements in science and the humanities since the thirteenth century. Everywhere the POWs looked, it seemed, war had not punctured the nimbus of this great city. The residents’ belief that Dresden was inviolable because of its treasures had given rise to a sense that they were on the sidelines of the war. Proof lay in the fact that there hadn’t been a serious air attack, only occasional strikes."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn53",
      "id": "ch3-fn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" The week before Christmas, the local defense commissioner, referring to the fighting in the Ardennes, declared, “This Christmas will be beautified for us by the fact that we can see our people back on the offensive.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn54",
      "id": "ch3-fn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" To ring in the holidays, the renowned boys’ choir of Dresden’s oldest school had performed in concert under the towering dome of the mid-eighteenth-century Frauenkirche, where Johann Sebastian Bach had once given a recital. At the opera house, the city’s Hitler Youth, standing before a red curtain displaying a giant black swastika encircled in white, had sung patriotic and traditional songs of the season."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn55",
      "id": "ch3-fn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The prisoners walked through the cobblestone streets under guard, largely ignored by Dresdeners. Work details of captives had become part of the city’s traffic for several years now. Most mornings, small groups of them could be seen waiting at tram stops, accompanied by a guard who was either elderly, injured, or otherwise unfit for frontline duty. The city was under considerable stress, however, from the thousands of German refugees streaming into Dresden from the east, fleeing the advance of Marshal Ivan Konev’s Ukrainian army. The population had almost doubled, from six hundred thousand to a million. Six thousand refugees were living in a cavernous air raid shelter beneath the railroad station designed to hold only two thousand. Some of the strain on the overcrowding situation had been relieved by the clockwork deportation of Dresden Jews. Of the approximately six thousand at the beginning of the war, there were only a few hundred Jewish residents left, and they were slated for removal to the death camps later that spring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men of Arbeitskommando 557 finally arrived at their assigned quarters located in the oldest neighborhood in Dresden, the Altstadt, on the Grosses Ostragehege, a large area of common land. They were housed in a large rectangular slaughterhouse converted into a POW camp with the addition of an encircling wall topped by barbed wire. Despite the building’s intended purpose—to prepare animals for slaughter—Vonnegut found nothing objectionable about this “nice new cement-block hog barn,” outfitted with double-decker bunks, and tables and chairs, but only two small stoves for warmth."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn56",
      "id": "ch3-fn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The latrine was in the yards, and farther away was a tall warehouse beneath which were two levels of basements so deep they provided natural cold storage for hanging sides of meat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men assembled in the yard for instructions from an SS captain, a short middle-aged man with a small mustache like Hitler’s."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn57",
      "id": "ch3-fn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" The name of their compound, he said loudly, was Schlachthof-Fünf—Slaughterhouse-Five. It would be pointless to try to escape because the war was finished."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn58",
      "id": "ch3-fn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Even so, escaping POWs were still enemy soldiers and would be shot. Likewise, plundering was another offense punishable by firing squad."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn59",
      "id": "ch3-fn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" And third, the guards were unlikely to know any English. Good daily relations necessitated an interpreter with enough knowledge of both languages to maintain lines of communication. The captain asked for volunteers who would admit to knowing enough German to serve as translator."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn60",
      "id": "ch3-fn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" The interpreter would be exempt from some work assignments because he would have to supervise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut and three others volunteered, including Bob Kelton from the reconnaissance squad. Each was interviewed until the choice came down to two candidates: Vonnegut or Kelton. Vonnegut was chosen because he was more proficient in the language—a benefit of his two years of high school German."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn61",
      "id": "ch3-fn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" From now on, he would serve as the foreman who would relay work orders to POWs and represent the prisoners if they had a complaint.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The following morning someone banging on a pan outside the slaughterhouse woke them up, yelling, “Get up, you lousy Chicago gangsters! Work, work, you lazy gangsters!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn62",
      "id": "ch3-fn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The men—most of whom had spent a good part of the night in the latrine with dysentery—assembled in the yard, exhausted. The noisemaker was a blond Hitler Youth about seventeen years old who lived on a mink farm, but relished coming into the city every day to play Nazi martinet."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn63",
      "id": "ch3-fn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" He had been issued a rifle because his uncle was the former mayor of Dresden. Flanking him was a gray-haired sergeant, one eye covered by a black patch—“One Lamp Louie,” the prisoners decided to call him. “You gangsters!” shouted the teenager. “We will show you how to work.” He paced back and forth, rifle slung over his shoulder, one hand behind his back, looking tough."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn64",
      "id": "ch3-fn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" The men derisively nicknamed him “Junior.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their first assignment, One Lamp Louie patiently announced, would be clearing a side street blocked by rubble from an apartment building and grocery store destroyed during a minor bombing raid. In a double column they filed out the gate and were led by a handful of guards, including Junior, to the work site, where an avalanche of broken bricks and masonry had created a hillock in the middle of the street. Wagons stood nearby to haul the debris away. As the men worked, they uncovered bits of month-old food such as cookies from the grocery store—dirty and gritty but preserved by the cold and edible."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn65",
      "id": "ch3-fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Looting was punishable by firing squad, but surreptitious bites of something now and then seemed reasonable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next day, and for several days afterward, women in the neighborhood left sandwiches for the prisoners wrapped in newspaper, perched on the rubble about half a block away. But one afternoon the guards ambushed them doing it and chased them off. The women didn’t come back."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn66",
      "id": "ch3-fn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ETURNING TO")]), _vm._v(" the barracks after a day’s labor, the men received a bowl of watery soup and a half-inch-thick slice of black pumpernickel bread. Two times a week, bits of meat floated in the soup, and sometimes a piece of cheese accompanied the bread. The bread they were told to save until morning when the ersatz coffee arrived. Weekly Red Cross packages were supposed to be delivered, containing two pounds of tinned meat, one pound of powdered milk, sugar, prunes, raisins, M&M’s, and dried biscuits that would puff up in water. But full packages arrived only once; then partial packages started to come infrequently with less and less food inside."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn67",
      "id": "ch3-fn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" The men began to starve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Food—just the word "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("food")]), _vm._v("—became sacred, an object of veneration and fascination. The prisoners described it, daydreamed about it, made menus of delicacies they were going to eat when they got home again. A favorite subject was Thanksgiving dinner, and how bevies of mothers and grandmothers brought bountiful dishes to dining room tables of grateful, waiting relatives. Vonnegut obsessed about candy bars. He swore he was going to eat every kind ever made when he got home—Almond Joy, Milky Way, PayDay, Hershey’s, Clark Bar—and loved to talk about what it would be like with his mouth stuffed. A fellow prisoner told him to shut up about it, and they got into an argument."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn68",
      "id": "ch3-fn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("White patches began appearing on Vonnegut’s skin—impetigo from vitamin deficiency. His job as foreman required him to negotiate occasionally between the POWs and the guards, but hunger was making it hard for him to think. Some of their captors were fair, concerned about keeping the peace to avoid trouble with their superiors. One Lamp Louie, in particular, came across as avuncular and made small talk in broken English with the men. But others were sadistic."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn69",
      "id": "ch3-fn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Junior roamed everywhere like a ferret hunting for the weak."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn70",
      "id": "ch3-fn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" One of his favorite tricks was to catch a man bending over and then hit him between the legs with the rifle butt."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn71",
      "id": "ch3-fn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To dull the ache in his belly and sharpen his wits, Vonnegut, like everyone else, bartered smokes for food and vice versa. A good touch for food was Private Edward “Joe” Crone from Rochester, New York, because he would always swap his portions for smokes. Feeling a little guilty, the other prisoners took his bread, cheese, or soup in exchange for cigarettes, which he constantly craved.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In fact, there was something unworldly, and definitely unsoldierly, about Crone all around. Just a glance at his childlike face framed by big ears said he would never have a nickname like “Rocky” or “Brownie” the way two other guys in the Arbeitskommando did."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn72",
      "id": "ch3-fn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" He told everyone he was going to be ordained an Episcopalian minister when he got home. Before the war, as proof of his seriousness about his ministerial calling, he had listed on his application to Hobart College the dates of five years of perfect attendance at St. Paul’s Episcopal Sunday School in Rochester. His high school assistant principal, wondering how to praise a youngster who had a reputation for being physically awkward and shy, recommended Joe to the admissions office at Hobart as a young man “possessed of great moral courage.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn73",
      "id": "ch3-fn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In his sophomore year at Hobart, he was drafted and Joe made an uncomplaining but terrible infantryman. On long marches, his assigned buddy in the 423rd regiment would get fed up having to “walk behind him and pick up all the utensils falling out of his backpack. He could never do it right.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn74",
      "id": "ch3-fn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" He seemed unwilling to believe that his survival would largely depend on what he carried. Observing him, Vonnegut realized, “Joe didn’t understand the war and of course there was nothing to understand. The world had gone completely mad.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn75",
      "id": "ch3-fn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In this bewildered young man who kept expecting a rationale that would explain to his satisfaction the ultimate bedlam that is war, Vonnegut later found the protagonist, Billy Pilgrim, for his novel "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Slaughterhouse-Five")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OME LUCK")]), _vm._v(" came Vonnegut’s way when he was assigned to something better than clearing rubble—better because it would put him in the vicinity of food. He and a dozen other POWs were transferred to a malt factory, unloading bags of grain from boxcars and filling up burlap sacks with it before hauling them to a storage area.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In one part of the building, ovens roasted the ingredients of imitation coffee: wheat, sugar beet shavings, and chicory. In another section there was a kitchen where women were cooking and straining, in bubbling pots, malt and barley mash into high-carbohydrate syrup for pregnant women. He found excuses—everyone in the work detail did—to cut through the kitchen. As he passed the vats of malt stuff, he dawdled. Then, if the cooks were busy, he shoved a hot, dripping dollop of it into his mouth with a spoon. The women knew what he and the others were doing, but they “were sympathetic human beings,” remembered one of the prisoners. They turned their backs just long enough so that ravenous young men—if they were quick and discreet—could gulp a dark golden blob of the wonderful syrup, which, said one, “warmed our stomachs and gave us additional energy and the desire to keep living.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn76",
      "id": "ch3-fn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NE DAY,")]), _vm._v(" when the men returned to the slaughterhouse, a stranger with an odd English-American accent hailed them. He was a representative of the Red Cross, he said, just arrived to check on their welfare. Were the fellas getting enough to eat? Were they okay? Naturally, the men showered him with complaints about the food, the threadbare uniforms, and the lack of wood for the stoves on cold nights. He listened with concern and recommended that they not wait for things to improve, because the war was turning against the Allies. The defeat in the Ardennes was just the beginning. It was true! In the meantime, the Germans were forming an elite unit of top-notch GIs to fight the Russians on the eastern front. Anybody who signed up would be guaranteed the works: warm uniforms, good food, and, most important, dignity. All they had to do was climb aboard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No one spoke, so the stranger went through his spiel again, this time a little more urgently, until the POWs communicated by their throat clearing and loud spitting that they were getting annoyed. He shrugged, promised to report back to the Red Cross, and strolled away, seemingly unconcerned."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn77",
      "id": "ch3-fn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" The following day, they found flyers left on their bunks awaiting their signature.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut, thinking about the stranger’s performance—weirdly scripted right down to using wooden American slang—decided he was a German actor hoping to euchre starving prisoners into fighting for the Reich if it meant food."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn78",
      "id": "ch3-fn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE BARRACKS")]), _vm._v(" had to be scrubbed down every day, and it fell to Vonnegut to tell the five prisoners on that detail what the guards wanted done, though after a month in the compound his supervision was hardly needed. Usually, his translations began, straight-faced, with “What these cocksuckers want us to do is…”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn79",
      "id": "ch3-fn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" The men moved slowly, hobbled by lack of food as they swept the floor, cleaned out the potbellied stoves, wiped down the tables, and, last, emptied the brimming cans in the latrine. They went about the tasks, step by step, like tired automatons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One morning Vonnegut watched with irritation as a new guard hassled a prisoner who was half lying on a table because he was sick, dragging a rag back and forth. The guard poked him with his rifle, prodding him to move faster. Clutching his stomach, the prisoner resumed wiping as best he could. But the guard, still not satisfied, raised his rifle and brought the butt down hard on the man’s ribs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You fucking swine,” Vonnegut said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The guard struck him with the rifle, knocking Vonnegut out."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn80",
      "id": "ch3-fn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His court-martial began the same day. The captain informed him that as translator he had insulted the honor of Germany and abused the privileges accorded him. Then he was beaten for insubordination. At the slaughterhouse, the men were taken aback at how he’d been worked over."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn81",
      "id": "ch3-fn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Not only had he been smashed in the face by the guard; his collar was dark with blood from a blow behind the ear that had split his scalp."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn82",
      "id": "ch3-fn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" He would no longer be their foreman, he explained—another prisoner would be both interpreter and in charge of the rations. From now on he would be just a laborer.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("H"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("E FELL")]), _vm._v(" in for roll call the next morning, noticing Junior off to the side, just staring at him. The “pain in the ass,” as he was ubiquitously known, had gotten up early and made sure to bring his rifle, but this time a sheathed bayonet was attached to it. A new game was about to begin, one that Junior had invented, and involving only two players: himself and Vonnegut.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Each day, for weeks, as we reached our place of work,” said another POW, “and the other ten or twelve guards scattered out among the one hundred fifty of us prisoners, the obnoxious kid whom we had nicknamed Junior, would affix his bayonet to his rifle and then follow Kurt Vonnegut around, hour after hour.” Whenever Vonnegut paused, slowed down, or stopped for a breath, Junior would jab him with the steel tip of the bayonet and snarl, “Vonnegut! You are lazy. You Americans are all lazy. You do not know the meaning of work. We Germans are strong!” The idea was to bait him into losing his cool. If he slapped away the bayonet, Junior could report that the prisoner had threatened him."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn83",
      "id": "ch3-fn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The contest continued as the other prisoners watched the “trial of will between Junior and Kurt,” said one, “wondering who would eventually triumph.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn84",
      "id": "ch3-fn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Every night before lockup, Junior obviously relished ordering him to perform one last duty: emptying the latrine. “Vonnegut, you must clean das shitters,” forcing him to go barefoot in the snow at times."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn85",
      "id": "ch3-fn85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" But the tall American private wordlessly did that too and never gave his personal guard an excuse to have him killed.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE WINTER")]), _vm._v(" weather in Dresden lifted abruptly on Shrove Tuesday, February 13, 1945, ushering in a hint of spring. On this last day before the beginning of Lent, small children begged to be allowed to wear their costumes early for the traditional Carnival Night, and teenage girls hurried to hem their dresses in time for visits to relatives’ homes. North of the Elbe River, the Circus Sarrasani finished erecting its huge domed tent, expecting a full house because the skies promised to be clear."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn86",
      "id": "ch3-fn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" The POWs were vaguely aware of the holiday, but everything seemed to be happening far away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That night, air raid sirens sounded at 9:51 "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PM.")]), _vm._v(" Many of the Shrove Tuesday celebrants returning home barely hurried. Looking up, they saw no bands of blue-white searchlights crisscrossing the darkness overhead and no antiaircraft guns pounding at enemy planes, because there were no searchlights or antiaircraft guns remaining in the city at all. They had been dismantled and taken by trucks to protect the industrial areas of the Ruhr Valley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ten minutes after the air raid sirens began moaning, brilliant magnesium parachute flares fell from the sky—“Christmas trees,” some romantic-minded Germans called them."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn87",
      "id": "ch3-fn87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Dresden’s buildings, fountains, statues, trees, rail lines, the zoo, the Circus Sarrasani—the Elbe River itself—were all illuminated for the last time, in a kind of flickering snapshot of seven hundred years of European civilization.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Looking down, RAF crews of eight hundred Avro Lancaster bombers saw their target crystallized by the flares and got ready to drop 1,400 tons of high-explosive bombs and 1,180 tons of incendiary bombs on the city. The first would devastate the railway yard, a meeting place of main lines to eastern and southern Germany, Berlin, Prague, and Vienna, and destroy Dresden’s roads and telephone lines; the second would melt the rubber and lubricants on the machinery in factories, rendering them useless. Thirty-five miles away to the southwest, over Chemnitz, an equal number of bombers were pounding more railway yards and factories, and smaller groups were attacking Böhlen (a town south of Leipzig), Nuremberg, Bonn, and Dortmund."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn88",
      "id": "ch3-fn88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" With the infrastructure destroyed in key places, the Red Army would have an easier time advancing east. Regardless, the Russians would lose 405,000 troops in the last forty-two miles approaching Berlin, about the number of American army soldiers who died during all of World War II."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn89",
      "id": "ch3-fn89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At 10:05 "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PM,")]), _vm._v(" the target finder over Dresden in a howling Mosquito bomber dropped a red flare and called out into his headset, “Tally ho!” The first attack had begun."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn90",
      "id": "ch3-fn90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NE")]), _vm._v(" L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMP")]), _vm._v(" Louie roused the POWs out of their bunks, hurried them across to the yard, and then sent them down the precipitous steps of the storage building toward the lower basement, sixty feet underground. A German corporal and three privates rushed behind, shutting the steel door after them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was room for everyone on the floor between the sides of beef hanging in rows from the ceiling on tenterhooks. Vonnegut listened, as “Giants stalked the earth above us. First came the soft murmur of their dancing on the outskirts, then the grumbling of their plodding towards us, and finally the ear-splitting crashes of their heels upon us.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn91",
      "id": "ch3-fn91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" Each convulsive blast overhead shook the rows of beef, making them dance, and white calcimine dust fell from the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even at eight thousand feet, it was hot work for the RAF bomber crews. Thousand-degree heat scorched the bellies of the planes, and smoke rose to fifteen thousand feet, making the aviators wet with perspiration. The intensity of the firestorm below created superhot tornadoes, mile-high vortexes ripping oxygen from the air to feed their roaring, thermal engines. The torquing effect on the atmosphere hurled people, animals, and furniture skyward, up from a city that was falling down underneath them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The director of the Historical Museum and Weapon Gallery ran through the streets hoping to save a truck loaded with 154 paintings and irreplaceable items that had been due to leave the next day ahead of the Russian advance. The truck had left, but when he reached the museum, where forty-two large paintings still hung on the walls, too large to be moved, the building was in flames.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Below ground, thousands of Dresdeners became terrified at the thought of being buried alive. A seventeen-year-old girl cowering in her nightgown, “didn’t even feel the cold, for the light went out, the children immediately began screaming again, then three of the women began to scream and rage like mad, while one old woman stood in a corner and prayed to God from the bottom of her heart.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn92",
      "id": "ch3-fn92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" In another basement, an eleven-year-old girl saw her father plant his feet and push with all his strength against a wall beginning to collapse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Three hours after the first attack, the second wave of RAF bombers flew over as survivors, rescue squads, and firefighters scurried through the streets, lured above ground by a false notion that the bombing had ceased. Five hundred Lancasters released one thousand tons of explosives. At the Dresden train station, with its huge, vaulted roof, where thousands of people had crammed into the city’s largest shelter during the first bombing wave, still more tried forcing their way in during the second raid, creating strata of corpses from the platforms to the bottom of the shelter.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("T DAWN")]), _vm._v(" on Wednesday morning the fourteenth, approximately eight hours after the first attack, Vonnegut and the others climbed the steps, Lazarus-like, to see what had happened. Overhead, P-51 Mustang fighters zoomed over streets and bridges, strafing anything that moved, adding fatalities like pebbles to the mountain of sixty thousand dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Blocking the top of the stairs was a side of beef, blown out from a locker and flash-cooked. The men rushed forward and tore off pieces, shoving them into their mouths and pockets. One Lamp Louie ordered them to stop, but they ignored him, grunting to get at the food. Shouting, he drew his Luger and fired several shots in air, getting them to back off, still chewing."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn93",
      "id": "ch3-fn93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" He instructed them to find a wagon and a tarpaulin to cover the meat. If they were seen stealing, there’d be trouble. They got a wagon, loaded it with meat, and then covered their treasure with blankets and pots."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn94",
      "id": "ch3-fn94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The guards ordered everyone to fall in. They had a predicament to solve: what to do with an enemy band of 150 men. The prisoners had practically no identity. They had emerged from the grave, so to speak, and if they were never seen again, it would be assumed that they had been turned to ash.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut waited like the others, a skeletal survivor with ulcerated legs, swaying in the wind that was bleak and raw, or warm and shimmering, depending on whether it came over the river at his back or from a fire. There was no sound except the brush of freezing air against his filthy clothes and the susurration of buildings burning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If he still had any feelings of being unique—the myth of invincibility typical of young people—despite the Battle of the Bulge, his capture, and incarceration, the dregs of those feelings must have drained off now, replaced by a profound loneliness and sense of almost cosmic isolation."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn95",
      "id": "ch3-fn95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" Hours passed, the morning of the fourteenth wore on, and the men were finally permitted to mill about, until word came down that all of Arbeitskommando 557 would be housed with the British South African troops in the suburb of Gorbitz, four miles to the west. The prisoners spent the rest of the morning commandeering enough carts and wagons for the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first men exiting the gate of the compound gasped in surprise. There was a nude woman with a beautiful figure, lying on her back, arms upraised. It was a mannequin, they realized, the pattern of its torched dress tattooed on its plaster thighs."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn96",
      "id": "ch3-fn96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" All that morning, the effects from volcanic blasts of high explosives and the firestorms continued to present freakish tableaux as the POWS struggled through the streets pushing or dragging their carts. They passed the corpse of a boy with his burned dog at the end of a leash; bodies of children dressed in party clothes; blackened drivers slumped at the wheels of their cars; couples who had leaped into fountains for safety and plunged into boiling water instead. The Dresden zoo, blown open by direct hits, had released its ark of animals into the wild. The men spotted a llama mounting slopes of debris. Exotic birds, with no trees to sit in, preened themselves on twisted iron railings. A chimpanzee, once popular with children, sat alone without hands."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn97",
      "id": "ch3-fn97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The procession staggered on. The wheels of the wagons, iron-rimmed, banged over rubble and slid through sticky, melted asphalt. The hubs and axles became clotted with reeking pitch. Heaps of fallen bricks and burning vehicles sometimes rendered the way ahead impassable, and then the caravan would have to turn back and find another route. Behind them, they heard explosions as a third wave of bombers at midday, this time consisting of three hundred American Eighth Air Force B-17s, dropped eight hundred tons of high explosives on the railway yards."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn98",
      "id": "ch3-fn98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The last half mile of the trek was a Sisyphean push up a steep brick street. To keep the wagons from rolling backward, the wheels had to be chocked every few feet with rocks. At last they arrived, welcomed by the British South Africans who had spent three years in captivity and were eager for news. One Lamp Louie assigned the bunks, two men in each one. It was strictly the luck of the draw, and Vonnegut got a spot in the front row near two toughs from New York who made it clear nobody had better mess with them."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn99",
      "id": "ch3-fn99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With everyone settled, the old sergeant went home. One of the prisoners later heard One Lamp Louie had lost his parents in the bombing."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn100",
      "id": "ch3-fn100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1-nospace"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HURSDAY MORNING,")]), _vm._v(" February 15, Arbeitskommando 557 was herded back into the city under guard to begin cleaning up Hell. Several times the column had to scramble behind heaps of rubble when a P-51 swung in and fired long bursts from its six .50-caliber machine guns, stitching the road with geysers of dirt. As they reached the outskirts of the city, gauntlets of incensed Dresdeners jeered and threw stones at them."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn101",
      "id": "ch3-fn101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They arrived at the slaughterhouse, where the SS captain with the Hitler mustache met them ready with new orders: the Arbeitskommando would be divided into work details of ten to fifteen. Some would clear rubble; some carry bodies; some retrieve what could be salvaged from the meat lockers. The punishment for looting was death by firing squad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eager for the work to get under way was Junior, bayonet affixed to his rifle, already rattling off his usual litany of invectives. To show he meant business, he punctuated his hectoring by jabbing a few of the men for good measure."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn102",
      "id": "ch3-fn102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" One of the prisoners, seeing the guards’ backs were turned, suddenly wrenched the rifle out of Junior’s hands and pushed him against a wall, the tip of the bayonet pressed to his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Get the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("fuck")]), _vm._v(" out of here!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The teenager slid sideways along the wall until he reached the corner and then ran away. No one saw him after that."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn103",
      "id": "ch3-fn103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("V"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ONNEGUT’S JOB")]), _vm._v(" was finding the remains of residents smothered in basements by the firestorms. Superheated tornadoes had sucked out the oxygen and turned hiding places into tombs. Basements, he said, “looked like a streetcar full of people who’d simultaneously had heart failure. Just people sitting there in their chairs, all dead.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn104",
      "id": "ch3-fn104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Teams from the Arbeitskommando passed through a cordon of German soldiers to begin what Vonnegut called a “terribly elaborate Easter egg hunt.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn105",
      "id": "ch3-fn105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" Some Dresdeners couldn’t contain their rage and grief as they watched the bodies of neighbors and family members, dragged by ropes around their ankles, disinterred from homes that had become their graves. A German officer grabbed one of the Americans, threw him against a wall, and put a pistol to his head, shouting, until the guards finally managed to calm him down."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn106",
      "id": "ch3-fn106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" In the streets, corpses were stacked high on wooden ricks, sprinkled with lime, and set afire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To reach flooded basements accessible by narrow stairs, the guards formed the prisoners into relays, sending one captive down at a time. “Encouraged by cuffing and guttural abuse, wade in we did,” wrote Vonnegut. “We did exactly that, for the floor was covered with an unsavoury broth from burst water mains and viscera.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn107",
      "id": "ch3-fn107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" Down there, the captives fought off hysteria when limbs of corpses snapped off or yanking a gas mask hose pulled off a head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Weeks passed, and the funk everywhere indicated that the bodies burned on pyres represented a fraction of what still remained below. The captain assembled the Arbeitskommando for new instructions: they were to recover items of identification and valuables only."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn108",
      "id": "ch3-fn108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Once the prisoners had resurfaced with everything they could find, German troops, some of them with experience in the death camps, stepped forward with flamethrowers. The ceremonies associated with respecting the dead had ended, and jets of ignited gasoline converted former sanctuaries for the living into catacombs.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("Y GOING")]), _vm._v(" into cellars day after day, a POW named Michael Palaia saw what all the other prisoners did, too. There were subterranean pantries of pickled asparagus, pickled onions, apple butter, cherries, string beans, beets, carrots, jams, jellies, sausage, pie fillings, and berry syrup—groaning shelves of sealed jars that a starving man could steal if he were careful."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn109",
      "id": "ch3-fn109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Palaia was one of the older prisoners and unable to withstand the deprivations as well as the younger men. While he was in a basement on the last day of March, someone shouted down at him, “Hey, the SS troops are coming, you better get your ass out of there, if there’s anybody in there!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn110",
      "id": "ch3-fn110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" Selecting a jar of pickled string beans, he stashed it under his coat and walked back out into the street. The Arbeitskommando was about to begin the return four-mile march to Gorbitz, and he was looking forward to sitting on his bunk and eating the beans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The SS officers who spotted him might have passed him by except he had made himself conspicuous through an earlier, fatal choice. From the frozen pile of overcoats inside the gate at Stalag IV-B, he had grabbed a heavy one that was different from most. On the back were the letters "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("CCCP")]), _vm._v("—the Russian abbreviation for Union of Soviet Socialist Republics. The SS ordered him to stop and unbutton his coat. There was nothing he could do—the contraband was a good-sized jar, and they plucked it out. Later that night, said Vonnegut, Palaia was court-martialed and ordered to sign a document he didn’t understand, admitting he was guilty of looting."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn111",
      "id": "ch3-fn111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning, April 1, Palm Sunday, guards issued shovels to Kurt and three other prisoners and took them to a rise within sight of the camp so the rest of the Arbeitskommando could see the example being set. The four men were ordered to dig graves while Palaia and a Polish soldier stood nearby."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn112",
      "id": "ch3-fn112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" When they had finished, an officer turned Palaia and the Polish soldier around by their shoulders, stepped back, and shouted an order. A firing squad shot the prisoners in the back; the Germans reloaded and shot them again. Vonnegut and the others were ordered to pick up the bodies and place them each in a grave. One of the Americans, knowing Palaia had been a Catholic like him, placed a rosary in his hands and said a prayer. Refilling the graves took a matter of minutes."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn113",
      "id": "ch3-fn113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later, when telling his family how impassively the executions were carried out, Vonnegut burst into tears. “The sons of bitches! The sons of bitches!”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn114",
      "id": "ch3-fn114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" He would model a character in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Slaughterhouse-Five")]), _vm._v(" on Palaia, Edgar Derby, the forty-four-year-old English teacher executed for stealing a teapot.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("Y MID-")]), _vm._v("A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PRIL")]), _vm._v(" 1945 there were signs that the war was ending. A furtive Dresdener in a dark suit passed the work gangs regularly and whispered the latest news while looking straight ahead: “The Allies are at Freiburg” (a day’s march away) or “the Rhine.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn115",
      "id": "ch3-fn115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" The German authorities, thinking ahead to the Allies’ arrival, gave the POWs an unprecedented two consecutive days off and arranged for their clothes to be washed while the men were deloused and stood around, naked beneath their greatcoats.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of them, James Mills, yellow with jaundice, was transported to Reviere Hospital at Görlitz, fifty-five miles east of Dresden."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn116",
      "id": "ch3-fn116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" Lying on a cot across from him was Joe Crone, the Hobart College undergraduate who had wanted to be an Episcopalian minister. He had never given up trading his food for cigarettes, in a childish gesture of defiance. The cigarettes he had craved, but he was sure he wouldn’t be allowed to starve. So he had held out, expecting the scales would be balanced out somehow through compassion, decency, or Christian charity. Now he was dying of the “thousand yard stare,” Vonnegut heard later. “When one chooses the thousand yard stare, this is what happens: the person sits down on the floor with his back to the wall, will not talk, will not eat, and just stares into the space in front of him.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn117",
      "id": "ch3-fn117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was nearly dead, but he only once asked Mills for help. “He was so skinny and weak and sick—he had to go to the bathroom during the night and all of us went over and tried to help him. We had to raise him up, get him at the angle, and somebody stick a can under him. He just absolutely couldn’t do nothing and it took all of us to get him up so he would take a leak.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn118",
      "id": "ch3-fn118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next morning he was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Life no longer made any sense to Crone, Vonnegut said. “And he was right. It wasn’t making any sense at all. So he didn’t want to pretend he understood it anymore, which is more than the rest of us did. We pretended we understood it.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn119",
      "id": "ch3-fn119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Germans buried him in a white paper suit because they had taken away his uniform while he was in the hospital. To Vonnegut, “he was beautiful,” a kind of holy fool."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn120",
      "id": "ch3-fn120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb1"
  }, [_vm._v("O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("N")]), _vm._v(" F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RIDAY,")]), _vm._v(" April 13, a passing tradesman whispered to some prisoners that President Roosevelt had died. That night, the guards informed Arbeitskommando 557 that the prisoners would be leaving the city in the morning. The guards seemed agitated, as if fearing that some tectonic shift was about to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the next two days, the column of hundreds of POWs, British and American, marched southeast along the Elbe River to the town of Pirna, and then up into the high mountains along the border separating Germany and Czechoslovakia to the village of Hellendorf, fifty miles in all. From the direction of the march, and the remoteness of the village, it was clear that the Germans wanted to lay low until they could be certain of surrendering to Allied forces and not Russian. For three weeks, the Dresden prisoners waited without enough to eat. They foraged in the fields for grass and dandelions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The last straw for the guards came when Russian aircraft, roaring in low, machine-gunned anything on the ground, including cows grazing in fields. The Germans disappeared into the woods, leaving the British and American POWs to their fate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vonnegut, Bernie O’Hare, and four other men commandeered a horse and wagon, painted a white American army star on the sides, and plodded back in the direction of Dresden. Vonnegut couldn’t remember why they headed back to the city, but once they arrived, he said, they were captured by Russian troops, taken in rickety Model A trucks to the Elbe at Halle, and traded one-for-one for Soviet prisoners in the custody of the Americans. Some of these, Vonnegut later heard, were Gypsies and collaborators. The Soviets shot or hanged hundreds of them."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn121",
      "id": "ch3-fn121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At Camp Lucky Strike in Le Havre, France, the POW repatriation center, Vonnegut stood in line, tossed his clothes into a pile, was deloused and issued a fresh uniform. He had lost forty pounds from a frame that was already thin; his legs were ulcerated; and a few of his teeth were loose from symptoms of scurvy. There were days of red tape and waiting. Getting out of Germany, he complained to O’Hare, was like walking in sand."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn122",
      "id": "ch3-fn122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("During the trip home aboard a troopship, Vonnegut and O’Hare had time to talk. In Le Havre, O’Hare said, he had heard Mass and received communion for the first time in five months."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn123",
      "id": "ch3-fn123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" But it didn’t take, he told Kurt."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn124",
      "id": "ch3-fn124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Like Joe Crone, who saw with his thousand-yard stare a landscape where there was no God, O’Hare had lost his faith.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t like that,” Vonnegut wrote later. “I thought that was too much to lose.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch3_fn125",
      "id": "ch3-fn125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f27efee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0